import React from "react";

import { INTERNAL_LINKS } from "enum";
import DashboardSponsors from "./DashboardSponsors";
import CardsDashboards from "./CardsDashboards";
import {  Route } from "react-router-dom";

const SponsorDashboards = () => {
  return (
    <>
        <Route
            exact
            path={`${INTERNAL_LINKS.SPONSORS_DASHBOARD_LIST}`}
            render={(props) => <CardsDashboards {...props} />}
        />
        <Route
            exact
            path={`${INTERNAL_LINKS.SPONSORS_DASHBOARD_LIST}/:data`}
            render={(props) => <DashboardSponsors {...props} />}
        />
    </>
  );
};

export default SponsorDashboards;
